import { Cancel01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { Stepper } from "shared/app/InviteAndCreateModal/slices/InviteApplicants/components/Stepper";
import {
  IconButton,
  IconButtonSize,
  IconButtonVariant,
  Show
} from "shared/components";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";
import { Step } from "views/settings-integration/components/AddIntegrationModal/types";

const STEP_TITLES: Record<Step, string> = {
  [Step.FIRST]: "Choose integration",
  [Step.SECOND]: "Add credentials",
  [Step.THIRD]: "Add integration name",
  [Step.CHOOSE_LISTINGS]: "Choose listings",
  [Step.INTEGRATION_NAME]: "Add integration name"
};

interface HeaderProps {
  currentStep: Step;
  totalSteps: number;
  feedLabel?: string;
  /** Replaces the step's default title. */
  title?: string;
  onClose?: () => void;
}

export const Header = ({
  currentStep,
  totalSteps,
  feedLabel,
  title: titleOverride,
  onClose
}: HeaderProps) => {
  const { property: propertyLabel } = useUnitsPropertiesDictionary();
  const displayStepIdx =
    currentStep === Step.CHOOSE_LISTINGS ||
    currentStep === Step.INTEGRATION_NAME
      ? totalSteps - 1
      : Number(currentStep);
  const isChooseListings = currentStep === Step.CHOOSE_LISTINGS;
  const title =
    titleOverride ??
    (isChooseListings && feedLabel
      ? `Choose listings for ${feedLabel}`
      : STEP_TITLES[currentStep]);

  return (
    <>
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0 space-y-1.5">
          <h1 className="font-bold text-xl">{title}</h1>
          <Show if={isChooseListings}>
            <p className="text-sm text-content-400">
              Every available listing is included by default. Uncheck a{" "}
              {propertyLabel} you’re not ready to add yet — you can turn it on
              later from the {feedLabel} integration page.
            </p>
          </Show>
        </div>
        <Show if={Boolean(onClose)}>
          <IconButton
            HugeIcon={Cancel01Icon}
            size={IconButtonSize.SM}
            variant={IconButtonVariant.TEXT_BASE}
            onClick={onClose}
            aria-label="Close"
          />
        </Show>
      </div>
      <div className="my-6">
        <Stepper currentStepIdx={displayStepIdx} totalSteps={totalSteps} />
      </div>
    </>
  );
};
